import { Button } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';

const WidgetArrow = ({
  arrowButtonWidth,
  direction = 'left',
  selectedItem,
  numOfItems = 0,
  arrowIconSize,
  setSelectedItem,
  ariaLabel,
}) => {
  const showButton = direction === 'left' ? selectedItem > 0 : selectedItem < numOfItems - 1;
  const buttonAriaLabel =
    ariaLabel ?? (direction === 'left' ? 'Show previous item' : 'Show next item');
  const arrowButtonStyle = {
    width: arrowButtonWidth,
    minWidth: arrowButtonWidth,
    flex: `0 0 ${arrowButtonWidth}px`,
  };

  if (!showButton) {
    return (
      <span
        aria-hidden="true"
        className="d-flex flex-column align-items-center justify-content-center h-100 border-0 p-0"
        style={arrowButtonStyle}
      />
    );
  }

  return (
    <Button
      aria-label={buttonAriaLabel}
      className="d-flex flex-column align-items-center justify-content-center h-100 border-0 p-0 btn-transparent"
      style={{
        ...arrowButtonStyle,
        cursor: 'pointer',
      }}
      onClick={() => {
        setSelectedItem(direction === 'left' ? selectedItem - 1 : selectedItem + 1);
      }}
      type="button"
    >
      {direction === 'left' ? (
        <FaChevronLeft aria-hidden="true" color="white" size={arrowIconSize} />
      ) : (
        <FaChevronRight aria-hidden="true" color="white" size={arrowIconSize} />
      )}
    </Button>
  );
};

export default WidgetArrow;
